export default __webpack_public_path__ + "static/media/Parent_Illustrations-06.82502578.svg";